import React from 'react';
import Styles from './PaidPlanGate.module.css';
import { IoLockClosedOutline, IoCheckmarkCircle } from 'react-icons/io5';

type PaidPlanGateProps = {
  // その画面の「何をする機能で、なぜ有料にする価値があるか」を1〜2文で。
  message: string;
  // 任意：有料プランで使える項目を箇条書きで見せる。
  features?: string[];
};

// どの画面でも共通で末尾に付ける定型文。
const PLAN_LINE = '有料プラン限定で利用できます。プラン変更後にご利用いただけます。';

// 無料プランのときに、対象画面の中身の代わりに表示するロック案内。
// アプリ(salon_app)の PaidPlanLimitedBody と同じ考え方で、ナビ自体は
// 隠さず「有料にしないと使えません」を見せる。
const PaidPlanGate: React.FC<PaidPlanGateProps> = ({ message, features }) => {
  return (
    <div className={Styles.wrap}>
      <div className={Styles.card}>
        <div className={Styles.icon}>
          <IoLockClosedOutline />
        </div>

        <h3 className={Styles.title}>有料プラン限定の機能です</h3>
        <p className={Styles.message}>{message}</p>
        <p className={Styles.planLine}>{PLAN_LINE}</p>

        {features && features.length > 0 && (
          <div className={Styles.features}>
            <p className={Styles.featuresTitle}>有料プランでできること</p>
            <ul className={Styles.featuresList}>
              {features.map((text, i) => (
                <li key={i} className={Styles.featuresItem}>
                  <IoCheckmarkCircle className={Styles.featuresItemIcon} />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <p className={Styles.note}>
          プランの変更をご希望の場合は、担当者までお問い合わせください。
        </p>
      </div>
    </div>
  );
};

export default PaidPlanGate;
